import { useContext } from 'react'
import { ConfirmContext, AlertContext } from './confirmDialogContext'

/** await confirm('Sicuro?') oppure await confirm({ message, variant: 'danger', confirmLabel: 'Elimina' }) */
export function useConfirm() {
  const ctx = useContext(ConfirmContext)
  if (!ctx) throw new Error('useConfirm deve essere usato dentro <ConfirmDialogProvider>')
  return ctx
}

/** await alertDialog('Operazione completata') al posto di window.alert(...) */
export function useAlertDialog() {
  const ctx = useContext(AlertContext)
  if (!ctx) throw new Error('useAlertDialog deve essere usato dentro <ConfirmDialogProvider>')
  return ctx
}
